import { render } from "./formatJson.vue?vue&type=template&id=56c706b7"
import script from "./formatJson.vue?vue&type=script&lang=js"
export * from "./formatJson.vue?vue&type=script&lang=js"

import "./formatJson.vue?vue&type=style&index=0&id=56c706b7&lang=scss&scope=true"

import exportComponent from "D:\\project\\windy\\formatJson\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__